import { useState } from 'react';
import type { Episode } from '@/types';

interface EpisodeListProps {
  episodes: Episode[];
  total: number;
}

export default function EpisodeList({ episodes, total }: EpisodeListProps) {
  const [active, setActive] = useState(episodes[0]?.ep ?? 1);
  const current = episodes.find((e) => e.ep === active) ?? episodes[0];

  if (!current) return null;

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {episodes.map((e) => (
          <button
            key={e.ep}
            onClick={() => setActive(e.ep)}
            className={`cursor-pointer w-10 h-10 flex items-center justify-center rounded-md text-sm font-medium transition-colors ${
              active === e.ep
                ? 'bg-primary-500 text-white'
                : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
            }`}
          >
            {e.ep}
          </button>
        ))}
        {total > episodes.length && (
          <span className="w-auto px-3 h-10 flex items-center justify-center rounded-md text-xs text-foreground-400 bg-background-100">
            共 {total} 集
          </span>
        )}
      </div>

      <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
        <h4 className="font-heading font-semibold text-foreground-950">
          第 {current.ep} 集 · {current.title}
        </h4>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{current.summary}</p>
      </div>
    </div>
  );
}